import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { updateForgottenUserPassword, setSessionToken } from "../../controllers/AccountConnectionLayer";
import "../../style/AppPages.css";
import "../../style/FormStyles.css";
import { useTranslation } from 'react-i18next';

const ResetPasswordPage = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    const [responseUrl, setUrl] = useState("");

    const [formData, setFormData] = useState({
        password: "",
    });

    useEffect(() => {
        const restoreSession = async () => {
            if (responseUrl == ""){
                setUrl(window.location.hash);
            }
            const theUrl = window.location.hash;

            const hashParams = new URLSearchParams(window.location.hash); // Remove the '#' and parse

            const accessToken = hashParams.get("#access_token");
            const refreshToken = hashParams.get("refresh_token");


            if (accessToken && refreshToken){
                await setSessionToken({accessToken, refreshToken}, navigate);
            } else {
                // alert("Invalid reset link.");
                // navigate("/account/login");
            }
        };

        restoreSession();
    }, [navigate]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!formData.password) {
            alert(t("account.pleaseEnterNewPasswordInfo"));
            return;
        }

        const data = await updateForgottenUserPassword(formData.password, t);

        if (data) {
            navigate('/confirmation', { state: { message: data.message } });
        }
    }; 

    return (
        <div class="page-padding">
            <div class="forgot-password-container">
                <h1 className='title-login'>{t("account.forgotPasswordText")}</h1>
                <form onSubmit={handleSubmit} class="login-section"> 
                    <div>
                        <label>{t("account.emailLabel")}</label>
                        <input
                            type="password"
                            name="password"
                            placeholder={t("update.newPasswordLabel")}
                            value={formData.password}
                            onChange={handleInputChange}
                        />
                    </div>
                    <button type="submit">{t("account.resetPasswordLabel")}</button>
                </form>
            </div>
        </div>
    );
};

export default ResetPasswordPage;